<!--
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-04-28 17:25:48
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-27 17:05:21
-->
<script lang="ts" setup>
import type { PropType } from 'vue';
import { useAttrs, watch, withDefaults } from 'vue';
import { UploadDragger } from 'ant-design-vue';
import { UploadOutlined } from '@ant-design/icons-vue';
import type { Api, FileItem, IUpload } from '../types';
import { useUpload } from './useUpload';
import FileList from './_FileList.vue';

interface IUploadD extends IUpload {
  hiddenList?: boolean; // 隐藏列表

  api?: Api;

  params?: PropType<object>;

  multiple?: boolean;

  maxSize?: number;

  maxCount?: number;

  accept?: string;

  uploadNow?: boolean; // 立即上传

  readOnly?: boolean;
  bordered?: boolean;
  readOnlyStyle?: object;
  readOnlyClassName?: string | null;
}

const props = withDefaults(defineProps<IUploadD>(), {
  accept: '*',
  multiple: false,
  uploadNow: true,
  hiddenList: false,
  readOnly: undefined,
});

const emit = defineEmits(['completeCheckType', 'remove', 'changeOfFileList:fileList', 'fileResult']);

const { startUpload, fileListRef, beforeUpload, getBindValue } = useUpload(props, {
  emit,
  attrs: useAttrs(),
});

defineExpose({
  startUpload,
});

watch(
  fileListRef,
  () => {
    // eslint-disable-next-line vue/custom-event-name-casing
    emit('changeOfFileList:fileList', fileListRef);
    return fileListRef;
  },
  { deep: true }
);

/**
 * 删除
 * @param record
 */
function handleRemove(record: FileItem) {
  fileListRef.value = fileListRef.value.filter(o => o.uid !== record.uid);
  emit('remove', record);
}
</script>

<template>
  <UploadDragger
    v-bind="getBindValue"
    name="file"
    :disabled="getBindValue?.readOnly"
    :before-upload="beforeUpload"
    style="margin: 12px auto"
  >
    <p class="ant-upload-drag-icon">
      <UploadOutlined />
    </p>
    <p class="ant-upload-text">点击或拖拽文件到此处上传</p>
  </UploadDragger>

  <slot name="itemRender" :file="fileListRef">
    <FileList v-if="fileListRef.length > 0 && !hiddenList" :data-source="fileListRef" @handle-remove="handleRemove" />
  </slot>
</template>

<style scoped lang="less">
:deep(.ant-upload-list) {
  display: none;
}
</style>
